import styled from 'styled-components';
import { resetBtn } from 'styled-manila';

export const ThumbnailImgs = styled.div`
	margin-top: 16px;
	display: grid;
	grid-gap: 16px;
	justify-content: space-between;
	grid-template-columns: 1fr 1fr 1fr;
`;

export const ThumbBtn = styled.button`
	${resetBtn};
	border-radius: 4px;
	overflow: hidden;

	img {
		display: block;
		width: 100%;
		height: 100%;
		object-fit: cover;
	}
`;

export const ImagesContainer = styled.div`
	@media (min-width: 440px) {
		max-width: 400px;
	}
`;
